(() => {
  'use strict';
  if (window.rrCantonFairLoaded) return;
  window.rrCantonFairLoaded = true;

  function init(root) {
    if (root.dataset.cantonReady === 'true') return;
    root.dataset.cantonReady = 'true';
    const form = root.querySelector('form');
    const fields = [...root.querySelectorAll('[data-canton-field]')];

    fields.forEach((field) => {
      const clearValidity = () => field.setCustomValidity('');
      field.addEventListener('input', clearValidity);
      field.addEventListener('change', clearValidity);
    });

    form?.addEventListener('submit', (event) => {
      fields.forEach((field) => {
        field.value = field.value.trim();
        field.setCustomValidity(field.required && !field.value ? 'Please fill out this field.' : '');
      });
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      const values = Object.fromEntries(fields.map((field) => [field.dataset.cantonField, field.value]));
      const summary = root.querySelector('[data-canton-summary]');
      if (summary) {
        summary.value = [
          form.querySelector('[name="contact[Campaign]"]')?.value || 'Canton Fair',
          '',
          `Full Name: ${values.name}`,
          `Phone Number: ${values.phone}`,
          `Email Address: ${values.email}`,
          `Company Name: ${values.company}`,
          `Your Role: ${values.role}`,
          ...(values.social_platform ? [`Social Media Platform: ${values.social_platform}`] : []),
          ...(values.social_account ? [`Social Media Account: ${values.social_account}`] : []),
          '',
          `Source: ${form.querySelector('[name="contact[Source]"]')?.value || location.href}`
        ].join('\n');
      }
      // Keep Shopify's native submission and CAPTCHA flow. Success is server-rendered.
    });

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target || !root.contains(target)) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const heading = target.querySelector('h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      });
    });

    root.querySelectorAll('[data-canton-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const value = button.dataset.cantonCopy;
        const status = root.querySelector('[data-canton-copy-status]');
        let copied = false;
        try {
          await navigator.clipboard.writeText(value);
          copied = true;
        } catch (_) {
          // Older mobile and embedded browsers can lack the Clipboard API.
          const input = document.createElement('textarea');
          input.value = value;
          input.readOnly = true;
          input.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;pointer-events:none';
          document.body.append(input);
          input.select();
          input.setSelectionRange(0, value.length);
          try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
          input.remove();
          button.focus({ preventScroll: true });
        }
        if (status) status.textContent = copied ? 'WeChat ID copied.' : `Please copy this WeChat ID: ${value}`;
        if (copied) {
          button.textContent = 'Copied';
          window.setTimeout(() => { if (button.isConnected) button.textContent = button.dataset.copyLabel; }, 2200);
        }
      });
    });

    const focusTarget = root.querySelector('[data-canton-focus]');
    if (focusTarget && !window.Shopify?.designMode) {
      requestAnimationFrame(() => focusTarget.focus({ preventScroll: true }));
    }
  }

  function scan(scope = document) {
    if (scope.matches?.('[data-canton-fair]')) init(scope);
    scope.querySelectorAll('[data-canton-fair]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
